import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
export const stock = [
    { title: "Equity", value: "Equity" },
    { title: "Large Cap", value: "Large Cap" },
];
export const NfoInvestment = [{ title: "Lumpsum", value: "Lumpsum", rank: 1 }];
export const schemeType = [
    { title: "Regular", value: "Regular" },
    { title: "Direct", value: "Direct" },
];
export const ReturnOption = [
    { title: "Growth", value: "Growth" },
    { title: "Div Payout", value: "DivPayout" },
    { title: "Div Reinv", value: "Div Reinv" },
];
export const DivFrequency = [
    { title: "Yearly", value: "Yearly" },
    { title: "Interim", value: "Interim" },
];
export const SebiRules = (React.createElement(React.Fragment, null,
    React.createElement("span", null, "As per SEBI rules, ledger based payment mode is discontinued for Mutual Funds. Once you click on confirm your order will be placed and direct you to make payment from your registered bank account. Please note that the order value will not be debited from your ledger and order placement will be deemed incomplete without the payment being made successfully")));
export const SebiRulesTop = (React.createElement(React.Fragment, null,
    React.createElement("span", null, "NAV date applicable for orders is subject to realisation of funds with exchange (BSE STAR MF)")));
export const SebiRulesBottom = (React.createElement(React.Fragment, null,
    React.createElement("span", null, "BEE STAR MF cut off is 12,50 PM for liquid funds and 220 PM for any other fund. Please note that this is it addition to the fund realisation condition stated above")));
export const preffredTop = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "" },
        "Exchange has direct integration with these banks",
        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left noti-10-small ms-1", value: "Read More" }))));
export const upiIddropdown = [
    { title: "HDFC Bank - 8237463284836", value: "Ids1" },
    { title: "HDFC Bank - 8237463284836", value: "Ids2" },
    { title: "HDFC Bank - 8237463284836", value: "Ids3" },
    { title: "HDFC Bank - 8237463284836", value: "Ids4" },
];
export const DiffBankAccountDesc = (React.createElement(React.Fragment, null,
    React.createElement("span", null, "Exchange has direct integration with these banks leading to faster credit of fund into exchange bank accounts and thus a higher probability of receiving NAV of same date. Subject to fund cutoff timings for same day NAV applicability and actual fund realization time.")));
export const PaymentSucessMsg = (React.createElement(React.Fragment, null,
    React.createElement("span", null,
        "Your payment for Lumpsum investment is ",
        React.createElement("br", null),
        " successful. Invested units will be added to your ",
        React.createElement("br", null),
        " holdings within 2 working days")));
export const PaymentFailMsg = (React.createElement(React.Fragment, null,
    React.createElement("span", null,
        "Your payment for Lumpsum investment has failed ",
        React.createElement("br", null),
        " due to insufficient amount")));
export const AddUPIMsg = (React.createElement(React.Fragment, null,
    React.createElement("span", null, "To verify UPI ID, you need to transer Rs.50 to your demat account")));
